import { selectFeatureToggleState } from '@features/feature-rollout-toggle';
import { useFeatureFlag } from '@features/user';
import { useFeatureGate } from '@services/statsig';
import { useAppSelector } from '@store/hooks';

/**
 * Determines whether the user should be routed to the encounters flow.
 *
 * True when:
 * 1. encounters backend flag is enabled (always — handles V1 and V2), OR
 * 2. V2 gate enabled AND toggle preference is NOT explicitly "classic"
 */
export function useShouldUseEncounters(): boolean {
  const encountersEnabled = useFeatureFlag('encounters');
  const v2GateEnabled = useFeatureGate('feature_encounter_view_v2');
  const toggleState = useAppSelector(state =>
    selectFeatureToggleState(state, 'feature_encounter_view_v2'),
  );
  const v2Preference = toggleState?.preference ?? null;

  return encountersEnabled || (v2GateEnabled && v2Preference !== 'classic');
}
